import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Clears the applied snapshot after the inherited active selection resets. */
export const clearAppliedSelectionsOnReset = store.effects.create(
  (
    feature: Plugin['feature'],
    appliedSelectionStorage: Plugin['_appliedSelectionStorage'],
  ) =>
    feature.actions.resetSelections.success
      .observe()
      .pipe(
        rxjs.map(action =>
          appliedSelectionStorage.actions.setLookup.from(action).create({}),
        ),
      ),
)
